import $ from 'jquery';

(function () {
	if (typeof window.CustomEvent !== "function") {
		(window as any).CustomEvent = (event: string, params?: any) => {
			params = params || {bubbles: false, cancelable: false, detail: null};
			const evt = document.createEvent('CustomEvent');
			evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
			return evt;
		};
	}
})();

const getCookieValue = (cookieName: string): string | null => {
	document.cookie.split('; ?').forEach(item => {
		if (item.length > cookieName.length && item.substring(0, cookieName.length) === cookieName) {
			return item.substring(item.indexOf('=') + 1);
		}
	});
	return null;
};
const makeFormButtonAction = (formButton: HTMLInputElement) => (e: Event) => {
	e.preventDefault();
	let successData: any;
	if (formButton.name !== 'submit') {
		successData = {};
		successData[formButton.name] = formButton.name;
	} else {
		successData = $(formButton.form).find('[name!="scriptlessDestination"]').serialize();
	}

	const formHandlingAction = (cookieValue: string) => () => {
		if (document.location.hash === '#dppArea') {
			document.location.hash = '';
			history.replaceState(history.state, document.title, window.location.href.split('#')[0]);
		}
		const dppHolders = document.querySelectorAll('.dppArea');
		for (let i = 0; i < dppHolders.length; i++) {
			dppHolders.item(i).classList.add('notCurrentState');
		}
		const dppReopeners = document.querySelectorAll('.dppReopener');
		for (let i = 0; i < dppReopeners.length; i++) {
			dppReopeners.item(i).classList.remove('notCurrentState');
		}
		if (cookieValue !== null && formButton.name !== 'submit') {
			const oldCookieValue = getCookieValue('core.allowed');

			if (cookieValue !== oldCookieValue) {
				document.cookie = 'core.allowed=' + cookieValue + ';path=/;samesite=lax';
				document.dispatchEvent(new CustomEvent('dppChange', {
					bubbles: false, cancelable: false, detail: {
						oldValue: oldCookieValue,
						newValue: cookieValue
					}
				}));
			}
		}
	};

	const mapButtonName = (buttonName: string) => formButton.form.getAttribute('data-value-for-button-' + buttonName) ?? buttonName;

	$.post({url: formButton.form.action, data: successData, dataType: 'json', timeout: 5000})
		.done(formHandlingAction(null)).fail(formHandlingAction(mapButtonName(formButton.name)));
	return false;
};

class DPPManager {
	private static instance: DPPManager;

	public constructor() {
		if (DPPManager.instance) {
			return DPPManager.instance;
		}
		DPPManager.instance = this;

		window.addEventListener('load', () => {
			if (!document.documentElement.classList) {
				return;
			}
			const cookiePolicyWrappers = document.querySelectorAll('.cookiePolicyWrapper');
			for (let cpi = 0; cpi < cookiePolicyWrappers.length; cpi++) {
				const cookiePolicyWrapper = cookiePolicyWrappers.item(cpi);

				const dppAreas = cookiePolicyWrapper.querySelectorAll('.dppArea');
				const dppReopeners = cookiePolicyWrapper.querySelectorAll('.dppReopener');

				const formButtons = cookiePolicyWrapper.querySelectorAll('.dppForm input[type="submit"]');
				for (let i = 0; i < formButtons.length; i++) {
					const formButton = formButtons.item(i);
					if ((formButton as any).attachEvent) {
						(formButton as any).attachEvent("click", makeFormButtonAction(formButton as HTMLInputElement));
					} else {
						formButton.addEventListener("click", makeFormButtonAction(formButton as HTMLInputElement));
					}
				}

				const cookiePreferencesLinkClickEventFunction = (e: Event) => {
					e.preventDefault();
					for (let j = 0; j < dppAreas.length; j++) {
						dppAreas.item(j).classList.remove('notCurrentState');
					}
					for (let j = 0; j < dppReopeners.length; j++) {
						dppReopeners.item(j).classList.add('notCurrentState');
					}
					return false;
				};

				const cookiePreferencesLinks = cookiePolicyWrapper.querySelectorAll('.cookiePreferencesLink');
				for (let i = 0; i < cookiePreferencesLinks.length; i++) {
					const cookiePreferencesLink = cookiePreferencesLinks.item(i);
					if ((cookiePreferencesLink as any).attachEvent) {
						(cookiePreferencesLink as any).attachEvent("click", cookiePreferencesLinkClickEventFunction);
					} else {
						cookiePreferencesLink.addEventListener("click", cookiePreferencesLinkClickEventFunction);
					}
				}
			}

			document.dispatchEvent(new CustomEvent('dppChange', {
				bubbles: false, cancelable: false, detail: {
					oldValue: '@first',
					newValue: getCookieValue('core.allowed')
				}
			}));
		});
	}

	public getDPPAllowed = (): string[] | null => {
		let cookieValue = getCookieValue('core.allowed');
		if (cookieValue == null) {
			return null;
		} else {
			cookieValue = cookieValue.trim();
			if (cookieValue.length == 0) {
				return [];
			} else {
				return cookieValue.split(/,\s*/);
			}
		}
	}
}

export default DPPManager;
